/*
 * Copyright (c) 2026.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {FileProcessingStatus} from "./FileProcessingStatus";
import {MarketplaceYml} from "./MarketplaceYml";

export interface MarketplaceYmlExport {
  id: number;
  createdAt: Date;
  createdBy: number;
  creatorIp: string;
  documentId: number;
  finishedAt: Date;
  marketplaceYml?: MarketplaceYml;
  marketplaceYmlId: number;
  status: FileProcessingStatus;
}
